document.addEventListener("DOMContentLoaded", function() {
  // Load More Button functionality for podcasts
  const loadMoreButtonPodcasts = document.getElementById("load-more-podcasts");
  let currentlyVisiblePodcasts = 3;  // Show 3 podcasts initially

  loadMoreButtonPodcasts.addEventListener("click", function() {
    const podcastList = document.querySelectorAll("#podcast-list .podcast");

    // Reveal next 3 podcasts (for a total of 6)
    currentlyVisiblePodcasts += 3;
    podcastList.forEach((podcast, index) => {
      if (index < currentlyVisiblePodcasts) {
        podcast.style.display = 'block';  // Show more podcasts
      }
    });

    // Hide the "Load More" button if all podcasts are visible
    if (currentlyVisiblePodcasts >= podcastList.length) {
      loadMoreButtonPodcasts.style.display = 'none';
    }
  });

  // Transcript toggle functionality
  const transcriptButtons = document.querySelectorAll('.transcript-toggle');
  
  transcriptButtons.forEach(button => {
    button.addEventListener('click', function() {
      const transcriptId = this.getAttribute('data-transcript-id');
      const transcriptElement = document.getElementById(transcriptId);
      
      // Toggle the visibility of the transcript
      if (transcriptElement.style.display === 'none' || transcriptElement.style.display === '') {
        transcriptElement.style.display = 'block';
        this.textContent = "Hide Transcript";
      } else {
        transcriptElement.style.display = 'none';
        this.textContent = "View Transcript";
      }
    });
  });
});
